import { render } from "./SKUBandingPage.vue?vue&type=template&id=99b3253e&scoped=true&ts=true"
import script from "./SKUBandingPage.vue?vue&type=script&lang=ts"
export * from "./SKUBandingPage.vue?vue&type=script&lang=ts"

import "./SKUBandingPage.vue?vue&type=style&index=0&id=99b3253e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b3253e"]])

export default __exports__